module.exports = __webpack_public_path__ + "ipad-air-silver@2x.png?09ab4f7a8fd1a5744e83398026743a07";